import { useEffect } from "react";
import { useAppearanceStore, systemTheme } from "@/store/appearanceStore";
import { useThemeStore } from "@/store/themeStore";
import { useMobileReader } from "@/hooks/useMobileMode";

/**
 * Applies the appearance: Light or Dark as chosen, or the system's, followed live
 * (a phone switches at sunset). Never chosen: a phone follows the system; the
 * desktop keeps the theme it has (Olivia, 10 Oct).
 */
export function AppearanceSync() {
  const appearance = useAppearanceStore((s) => s.appearance);
  const phone = useMobileReader();
  const followSystem = appearance === "system" || (appearance === null && phone);

  useEffect(() => {
    const setThemeName = useThemeStore.getState().setThemeName;
    const apply = (name: "light" | "dark") => {
      if (useThemeStore.getState().themeName !== name) setThemeName(name);
    };
    if (appearance === "light" || appearance === "dark") {
      apply(appearance);
      return;
    }
    if (!followSystem) return;
    apply(systemTheme());
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    const onChange = () => apply(systemTheme());
    mq?.addEventListener?.("change", onChange);
    return () => mq?.removeEventListener?.("change", onChange);
  }, [appearance, followSystem]);

  return null;
}
